import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { importOnIdle, installChunkErrorRecovery, installHydrationDiagnostics, assertRuntimeState } from "@/lib/runtime";
import { initializeTheme } from "@/lib/theme";
import { ensureLanguageSynchronization, initializeLanguage } from "@/lib/routes";

initializeTheme();
initializeLanguage(window.location.pathname);
installChunkErrorRecovery();
installHydrationDiagnostics();
assertRuntimeState([
  () => ensureLanguageSynchronization(window.location.pathname),
]);

createRoot(document.getElementById("root")!).render(<App />);

importOnIdle(() => import("@/components/home/CategoriesSection"));
importOnIdle(() => import("@/components/home/SpotlightGallery"));
importOnIdle(() => import("@/components/home/ManufacturerScroll"));
importOnIdle(() => import("@/components/home/SceneTransition"));
